const ENDPOINT = '/.netlify/functions/spotify';
const POLL_MS = 30000;

let currentProgress = 0;
let currentDuration = 0;
let isCurrentlyPlaying = false;

function tickProgress() {
    if (!isCurrentlyPlaying || currentDuration === 0) return;
    currentProgress = Math.min(currentProgress + 1000, currentDuration);
    const pct = (currentProgress / currentDuration) * 100;
    document.getElementById('spotify-progress').style.width = `${pct}%`;
}

function setLayout(isIdle) {
    const spotifyCol = document.getElementById('spotify-col');
    const dribbbleCol = document.getElementById('dribbble-col');
    if (!spotifyCol || !dribbbleCol) return;

    if (isIdle) {
        spotifyCol.style.display = 'none';
        dribbbleCol.classList.remove('col-md-6');
        dribbbleCol.classList.add('col-md-12');
    } else {
        spotifyCol.style.display = '';
        dribbbleCol.classList.remove('col-md-12');
        dribbbleCol.classList.add('col-md-6');
    }
}

function render(data) {
    const card = document.querySelector('.spotify-card');
    const indicator = document.getElementById('spotify-indicator');
    const title = document.getElementById('spotify-title');
    const artist = document.getElementById('spotify-artist');
    const context = document.getElementById('spotify-context');
    const link = document.getElementById('spotify-link');
    const albumImg = document.getElementById('spotify-album-img');
    const albumWrap = document.querySelector('.spotify-album-wrap');
    const progressFill = document.getElementById('spotify-progress');

    card.classList.remove('is-playing', 'is-paused', 'is-idle');
    card.classList.add(`is-${data.status}`);
    setLayout(data.status === 'idle');

    if (data.status === 'playing' || data.status === 'paused') {
        indicator.classList.toggle('playing', data.status === 'playing');
        title.textContent = data.title;
        artist.textContent = data.artist;
        link.href = data.songUrl;

        albumImg.src = data.albumImageUrl || '';
        albumImg.alt = data.album || '';
        albumWrap.classList.toggle('has-image', !!data.albumImageUrl);

        currentProgress = data.progress;
        currentDuration = data.duration;
        isCurrentlyPlaying = data.status === 'playing';

        progressFill.style.width = `${(currentProgress / currentDuration) * 100}%`;

        if (data.contextType && data.contextName) {
            const labels = { playlist: 'Playing from', album: 'From album', collection: '' };
            const prefix = labels[data.contextType] ?? 'From';
            const name = data.contextUrl
                ? `<a href="${data.contextUrl}" target="_blank" rel="noopener noreferrer">${data.contextName}</a>`
                : data.contextName;
            context.innerHTML = `${prefix} ${name}`.trim();
        } else {
            context.textContent = '';
        }
    } else {
        indicator.classList.remove('playing');
        title.textContent = 'Nothing playing';
        artist.textContent = '—';
        context.textContent = '';
        link.href = '#';
        albumWrap.classList.remove('has-image');
        isCurrentlyPlaying = false;
        progressFill.style.width = '0%';
    }
}

async function fetchNowPlaying() {
    try {
        const res = await fetch(ENDPOINT);
        const data = await res.json();
        render(data);
    } catch {
        // function unavailable (local dev without netlify dev)
    }
}

fetchNowPlaying();
setInterval(tickProgress, 1000);
setInterval(fetchNowPlaying, POLL_MS);
